export const removeLastArrayItem = (arr: any[]): any[] => arr.filter((item, index) => index !== arr.length - 1);
